"use client"

import {
  AppContextProvider
} from "@/components/App"
import Navigation from "@/components/Navigation"
import ToastContainer from "@/components/ToastContainer"
import {
  useAdapter
} from "@/hooks/Adapter/useAdapter"
import {
  BrowserPersistence
} from "@/util"
import {
  ApolloProvider
} from "@apollo/client"
import {
  useSearchParams
} from "next/navigation"
import {
  useEffect
} from "react"
import {
  Provider as ReduxProvider
} from "react-redux"
import HeaderSkeleton from "../Header/header-skeleton"
import {
  IpProvider
} from "../ip-provider"
import SizeChartDialog from "../size-chart-dialog"

const storage = new BrowserPersistence()

const Adapter = (props) => {
  const talonProps = useAdapter(props)

  const {
    showLoading 
  } = props || {}

  const {
    apolloProps, initialized, reduxProps 
  } = talonProps

  const searchParams = useSearchParams()

  // useEffect(() => {
  //     if (typeof window !== 'undefined') {
  //         window.__rum = {
  //             pid: '463m@c37f87b2369bfdc',
  //             endpoint: 'https://463m-default-cn.rum.aliyuncs.com',
  //         }

  //         const scriptEle = document.createElement('script')
  //         scriptEle.type = 'text/javascript'
  //         scriptEle.async = ''
  //         scriptEle.src = 'https://sdk.rum.aliyuncs.com/v2/browser-sdk.js'

  //         document.body.appendChild(scriptEle)
  //     }
  // }, [])

  useEffect(() => {
    // mailchimp相关逻辑
    const mc_cid = searchParams.get("mc_cid")
    const mc_eid = searchParams.get("mc_eid")

    if (!mc_cid && !mc_eid) {
    } else {
      if (
        storage.getItem("mc_cid") ||
                storage.getItem("mc_eid") ||
                storage.getItem("mc_lp")
      ) {
        // 已经存在数据, do nothing
      } else {
        storage.setItem("mc_cid", mc_cid)
        storage.setItem("mc_eid", mc_eid)
        storage.setItem(
          "mc_lp",
          globalThis.location.pathname + globalThis.location.search
        )
      }
    }
  }, [searchParams])

  // useEffect(() => {
  //     ;(function (w, d, s, l, i) {
  //         w[l] = w[l] || []
  //         w[l].push({
  //             'gtm.start': new Date().getTime(),
  //             event: 'gtm.js',
  //         })
  //         var f = d.getElementsByTagName(s)[0],
  //             j = d.createElement(s),
  //             dl = l != 'dataLayer' ? '&l=' + l : ''
  //         j.async = true
  //         j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
  //         f.parentNode.insertBefore(j, f)
  //     })(window, document, 'script', 'dataLayer', 'GTM-5TGRG42')

  //     window.dataLayer = window.dataLayer || []
  //     function gtag() {
  //         dataLayer.push(arguments)
  //     }
  //     gtag('js', new Date())

  //     gtag('config', 'G-N4YHRC2VGG')
  // }, [])

  if (!initialized && showLoading) {
    return <HeaderSkeleton />
  }

  if (!initialized) {
    return null
  }

  const children = props.children

  return (
    <ApolloProvider {...apolloProps}>
      <ReduxProvider {...reduxProps}>
        <IpProvider>
          <AppContextProvider>
            {children}
            <Navigation />
            <ToastContainer />
            <SizeChartDialog/>
          </AppContextProvider>
        </IpProvider>
      </ReduxProvider>
    </ApolloProvider>
  )
}

export default Adapter
